// extracted by mini-css-extract-plugin
export default {"Box":"table-group-module__Box__A0EJyRb","isOver":"table-group-module__isOver__MId8q2g"};